import { Grid } from '@material-ui/core'
import { RopTasksFilter } from 'components/Rop/RopTasksFilter/RopTasksFilter'
import { RopTasksList } from 'components/Rop/RopTasksList/RopTasksList'
import { Pagination } from '@material-ui/lab'
import React from 'react'
import { useStyles } from './tasks-list.styles'
import { useHomeStoreRop } from '../../../../../../context/HomeStore/Rop'

export const TasksList = () => {
  const classes = useStyles()

  const {
    homeStore: { tasksPagination },
    homeStoreFunc: { onTasksPaginationChange }
  } = useHomeStoreRop()

  return (
    <Grid container>
      <Grid item container>
        <RopTasksFilter />
      </Grid>
      <Grid item container style={{ marginTop: 50 }}>
        <RopTasksList />
      </Grid>
      <Grid item container style={{ padding: '12px 24px' }}>
        <Pagination
          variant="outlined"
          shape="rounded"
          size="large"
          className={classes.pagination}
          count={tasksPagination.count}
          page={tasksPagination.offset ? tasksPagination.offset : 1}
          onChange={onTasksPaginationChange}
        />
      </Grid>
    </Grid>
  )
}
